import { UploadControllerRegistry } from "@/application/upload/ports/UploadControllerRegistry";
import { StorageUploadController } from "@/application/upload/ports/StorageUploadService";

export class InMemoryUploadControllerRegistry
  implements UploadControllerRegistry
{
  private readonly controllers = new Map<string, StorageUploadController>();

  register(taskId: string, controller: StorageUploadController): void {
    this.controllers.set(taskId, controller);
  }

  get(taskId: string): StorageUploadController | undefined {
    return this.controllers.get(taskId);
  }

  remove(taskId: string): void {
    this.controllers.delete(taskId);
  }
}

